import React, { Component } from "react"
import Modal from 'react-modal'
import { Grid, Row, Col } from 'react-bootstrap'
import { connect } from 'react-redux'

import { createDeliveriesRerun } from '../../DataAnalytics/redux/dataAnalyticsActions'
// import { swalError, swalSuccess } from '../../../common/components/Swaler'

const customStyles = {
    content: {
        position: 'fixed',
        top: '20%',
        left: '12%',
        right: 'auto',
        bottom: 'auto',
        padding: 20,
        zIndex: 9999,
        border: 'none',
        width: '80%',
        height: '75%',
        backgroundColor: 'white',
        border: '1px solid lightgrey'
    }
}

const editableFields = 'queryindicators,pickupindicators,receivername,sendername'.toLowerCase().split(',')

class ReRunDeliveryModal extends Component {
    constructor(p) {
        super(p)

        this.state = { edited: true }
    }

    updateField = (e) => {
        this.setState({ [e.target.name]: e.target.value.toUpperCase(), edited: true })
    }

    send = () => {
        var obj = Object.assign({}, this.props.data, this.state)

        try {
            obj.queryIndicators = Object.entries(JSON.parse(obj.queryIndicators)).reduce((acc, [key, val]) => ({ ...acc, [key.toLowerCase()]: val }), {})
            obj.pickupIndicators = Object.entries(JSON.parse(obj.pickupIndicators)).reduce((acc, [key, val]) => ({ ...acc, [key.toLowerCase()]: val }), {})
        } catch (e) {
            console.log(e)

            return alert("Felaktig JSON")
        }

        console.log(obj)

        this.props.createDeliveriesRerun([obj]).then(t => {
            console.log(t)
        })
    }

    render() {
        return (
            <Modal
                ariaHideApp={false}
                isOpen={this.props.modalIsOpen}
                onRequestClose={() => this.props.closeModal()}
                style={customStyles}>

                <Grid fluid>
                    <Row>
                        <Col xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'right' }}>
                            <span onClick={() => this.props.closeModal()} className="closeButton2">X</span>
                        </Col>
                    </Row>

                    {Object.keys(this.props.data).sort().map(key => {
                        if (editableFields.indexOf(key.toLowerCase()) == -1) return null

                        const val = this.state[key] || this.props.data[key]
                        return (
                            <Row key={key}>
                                <Col xs={12} sm={1} md={1} lg={1}>
                                    {key}
                                </Col>
                                <Col xs={12} sm={11} md={11} lg={11}>
                                    {val.length > 50 ?
                                        <textarea style={{ width: '50%', height: 100 }} name={key} value={val} onChange={this.updateField}></textarea>
                                        :
                                        <input style={{ width: '50%' }} name={key} value={val} onChange={this.updateField}></input>
                                    }
                                </Col>
                            </Row>
                        )
                    })}

                    {this.state.edited ?
                        <Row style={{ marginTop: '10%' }}>
                            <Col xs={12} sm={12} md={12} lg={12}>
                                <div className="smallQbutton" style={{ width: '30%' }} onClick={this.send}>
                                    Skicka till servern
                                </div>
                            </Col>
                        </Row>
                        : null}

                </Grid >

            </Modal>
        )
    }

}

const mapDispatch = (dispatch) => ({
    createDeliveriesRerun: (deliveries) => dispatch(createDeliveriesRerun(deliveries)),
})

export default connect(null, mapDispatch)(ReRunDeliveryModal)
